import React, { ReactNode, useEffect } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Tooltip, TooltipPlacement } from '../../../atoms/Tooltip';
import { appendClassNames } from '../../../../lib/bemUtils/classname';
import { BtnModifier } from '..';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { ButtonProps } from '../../../../types/HtmlProps';
import { useRefProp } from './useRefProp';

type BtnButtonProps = ButtonProps & {
  modifier?: Modifier<BtnModifier>;
  tooltipPlacement?: TooltipPlacement;
  hideTooltipFromScreenReader?: true;
  focusOnMount?: true;
  children: ReactNode;
  ref?: React.Ref<HTMLButtonElement | null> | null;
};

export function Button({
  className,
  type,
  hideTooltipFromScreenReader,
  tooltipPlacement,
  children,
  modifier,
  focusOnMount,
  onClick,
  onKeyDown,
  onKeyUp,
  ref,
  ...props
}: BtnButtonProps) {
  const { innerRef, refCallback } = useRefProp(ref);

  useEffect(() => {
    if (focusOnMount && innerRef.current) {
      innerRef.current.focus();
    }
  }, [focusOnMount, innerRef]);

  return (
    <Tooltip attachTo={innerRef} placement={tooltipPlacement} hideTooltipFromScreenReader={hideTooltipFromScreenReader}>
      <button
        {...props}
        ref={refCallback}
        className={appendClassNames(className, bem('btn', modifier))}
        // eslint-disable-next-line react/button-has-type
        type={props['aria-disabled'] ? 'button' : type}
        role={props.role}
        onClick={!props['aria-disabled'] ? onClick : undefined}
        onKeyDown={!props['aria-disabled'] ? onKeyDown : undefined}
        onKeyUp={!props['aria-disabled'] ? onKeyUp : undefined}
      >
        {children}
      </button>
    </Tooltip>
  );
}
